export const ADD_SUCCESS = 'Новый владелец ЭЗС добавлен';
export const ADD_ERROR = 'Не удалось добавить владельца ЭЗС';
